import { useTranslation } from 'react-i18next';
import { useGetCurrenciesPreferenceQuery } from '@/store/services/lookups';

export const useCurrencyPreference = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError, isFetching } = useGetCurrenciesPreferenceQuery();
  
  const fetchedPreference = data || null;
  const currencyPreference = fetchedPreference || {
    code: 'SAR',
    nameAr: 'ريال سعودي',
    nameEn: 'Saudi Riyal',
    name: t('currency.SAR', 'SAR'),
    icon: 'SAR',
  };
  const currencyCode = currencyPreference?.code || 'SAR';
  
  return {
    currencyCode,
    currencyPreference,
    isLoading,
    isError,
    isFetching,
  };
};
